<template>
  <div>
    <!-- 日程时间检测  -->
    <a-modal
        :title="title+'时间检测'"
        :visible="visible"
        :footer="data.length === 0 ? null:''"
        @ok="okBtn"
        @cancel="cancelBtn"
        width="900px"
    >
      <div v-if="data.length">
        <div class="ConferenceHotel" v-for="(item,index) in data" :key="index">
          <a-table :columns="type === 1 ? columns : columnsPeople" :data-source="item" bordered :pagination="false">
             <span slot="beginTime" slot-scope="text, record">
               {{record.beginTime.slice(0, 10)}}
             </span>
            <span slot="time" slot-scope="text, record">
               <span style="color: red">{{record.beginTime.slice(10,19)}}-{{record.endTime.slice(10,19)}}</span>
             </span>
            <span slot="name" slot-scope="text, record">
               <span style="color: red">{{record.title}}</span>
             </span>
            <span slot="expertList" slot-scope="text, record">
               <span v-for="(item,index) in record.expertList" :key="index" style="color: red">
                 <span>{{item.name}}-{{item.hospital}}</span>
               </span>
             </span>
          </a-table>
        </div>
      </div>
      <div v-else style="text-align: center;margin: 80px 0 120px 0;">
        <admin_con style="font-size: 100px;" type="icon-tongguo"/>
        <div class="tips">恭喜你，没有时间冲突的{{title}}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {admin_icon} from "@/utils/myIcon";

export default {
  name: "HotelManagement",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    title:{
      type:String,
    },
    type:{
      type:Number
    },
    data:{
      type:Array,
      default:[],
    },
  },
  data(){
    return{
      columns:[
        {
          title: '地点',
          dataIndex: 'site',
          key: 'site',
          width:100,
        },
        {
          title: '日期',
          key: 'beginTime',
          dataIndex: 'beginTime',
          width:100,
          scopedSlots: { customRender: 'beginTime' },
        },
        {
          title: '时间',
          dataIndex: 'endTime',
          key: 'endTime',
          width:100,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: '专题/讲题',
          key: 'title',
          dataIndex: 'title',
          width:300,
          scopedSlots: { customRender: 'name' },
        },
      ],
      columnsPeople:[
        {
          title: '地点',
          dataIndex: 'site',
          key: 'site',
          width:100
        },
        {
          title: '日期',
          key: 'beginTime',
          dataIndex: 'beginTime',
          width:100,
          scopedSlots: { customRender: 'beginTime' },
        },
        {
          title: '时间',
          dataIndex: 'endTime',
          key: 'endTime',
          width:100,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: '专题/讲题',
          key: 'title',
          dataIndex: 'title',
          width:200,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '讲者主持',
          key: 'expertList',
          dataIndex: 'expertList',
          width:300,
          scopedSlots: { customRender: 'expertList' },
        },
      ],
      total:0,
      current:1,

      visibleModel:false,
      formModel:{},
      rulesModel:{
        hotelName: [{ required: true, message: '请输入', trigger: 'blur' }],
        hotelAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        HotelContact: [{ required: true, message: '请输入', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      titleModel:'',
    }
  },
  components:{admin_con: admin_icon},
  methods:{
    cancelBtn(){
      let flag = false;
      this.$emit("closeMain", flag); //子组件向父组件传值(开关)
    },
    onChange(page,pageSize){
      this.current = page;
    },
    okBtn(){

    },
  }
}
</script>

<style scoped lang="scss">
.ConferenceHotel{
  margin-bottom: 20px;
}
.tips{
  color: #333333;
  font-weight: bold;
  font-size: 25px;
}

</style>
